/**
 * Right-panel tab ids for the skill-groups feature. Shared between the manifest
 * (which registers the panel view) and the center views (which open/focus it via
 * `useLayoutStore`). Keep in sync with `manifest.ts`.
 */

/** "Link an existing skill" form (skill + grid + weight). Edit + create. */
export const SKILL_LINK_TAB = 'skill-link';
